module.exports = __webpack_public_path__ + "img/68.8bce8492.jpg";